import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import agent from '../../agent';
import {GridList, GridTile} from 'material-ui/GridList';
import Upload from './Upload';
import * as firebase from 'firebase';

class ImageUpload extends Component  {

  onFileLoad = (e, file) => {
    var thisRef = this;
    var storageRef = firebase.storage().ref();
    var uID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    var uID2 = uID.replace(/[xy]/g, function(c) {
        var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
        return v.toString(16);
    });
    var artistID = this.props.artistID;
    var metadata = {
      customMetadata: {
        'artistID': artistID
      }
    }

    storageRef.child('originals/'+uID2 + '.' + file.name.split('.').pop()).put(file, metadata).then(function(snapshot) {
      var images = thisRef.props.images;
      images.push({original: snapshot.metadata.fullPath, thumb:snapshot.metadata.fullPath.replace('originals', 'thumbs')});

      thisRef.props.valChange({images: images});
      agent.Artists.update(artistID, {images:images});
    });
  }

  deletePhoto = file => {
    var storageRef = firebase.storage().ref();
    var deleteRef = storageRef.child(file);
    var images = this.props.images.filter(image => {
      return image.original !== file;
    });
    console.log(images);
    this.props.valChange({images: images});
    agent.Artists.update(this.props.artistID, {images:images});

    // Delete the file
    deleteRef.delete().then(function() {
      console.log("DELETED");
    }).catch(function(error) {
      console.log("ERROR");
    });
  }

  render() {
    const divStyle = {
      margin: '10px 0px'
    };
    const gridList = {
      height: 400,
      overflowY: "auto"
    }
    const btnStyle = {
      margin: "12px 12px 12px 0",
      lineHeight: '30px',
    };

    return (

      <div style={divStyle}>
        <GridList style={gridList} cellHeight={200} padding={1} cols={2}>
          {this.props.images &&

              this.props.images.map((tile, index) => {
                return (
                  <GridTile
                    key={tile.original}
                    title={"Image " + (index+1)}
                    actionIcon={<IconButton onTouchTap={e => this.deletePhoto(tile.original)}><ActionDelete color="white" /></IconButton>}
                    cols={1}
                  >
                    <img src={"http://storage.googleapis.com/art-trove.appspot.com/" + tile.original} />
                  </GridTile>
                );
              })

          }
        </GridList>
        <Upload onFileLoad={this.onFileLoad.bind(this)}/>
      </div>
    );
  }
};

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/Admin/ImageUpload.js